export const enum AuthType {
  CORPORATE = 'corporate',
  PRIVATE = 'private',
}
